/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user-info[_ngcontent-%COMP%]{padding:0 1rem .5rem 1.5rem;margin-bottom:1.5rem;border-bottom:.15rem solid #eebf27}.user-info__inner[_ngcontent-%COMP%]{margin-top:-1rem}.user-info[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:.3rem 0}.user-info[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-right:2rem;color:#eebf27}"];
export { styles as styles };
